// Share images for pages that used to borrow the home or about image, so every page
// has its own picture in link previews and in Google Images. Made by
// tools/build-og-pages.py (which reads this list). File names and alt text start with
// "Zuzu Club", so the images show up when people search for Zuzu Club.
// After changing an image, bump PAGE_IMAGE_VERSION.

export const PAGE_IMAGE_VERSION = 10; // all share images rebuilt with "Zuzu Club" (23 Oct 2026)
// A page whose image changed later gets its own version, so link previews refresh.
const PAGE_IMAGE_VERSIONS: Record<string, number> = { '/whimsical-websites': 15 }; // 101 sites (27 Oct 2026)

// The competitor name for each comparison page.
export const ALTERNATIVE_NAMES: Record<string, string> = {
  '/7-cups-alternative': '7 Cups',
  '/omegle-alternative': 'Omegle',
  '/blah-therapy-alternative': 'Blah Therapy',
  '/talklife-alternative': 'TalkLife',
  '/chatcha-alternative': 'Chatcha',
  '/hearme-alternative': 'HearMe',
  '/supportiv-alternative': 'Supportiv',
  '/buddyhelp-alternative': 'BuddyHelp',
  '/wysa-alternative': 'Wysa',
  '/replika-alternative': 'Replika',
  '/mellow-alternative': 'Mellow',
  '/emerald-chat-alternative': 'Emerald Chat',
  '/whiteflag-alternative': 'WhiteFlag',
  '/wisdo-alternative': 'Wisdo',
  '/togetherall-alternative': 'Togetherall',
};

const ALTS: Record<string, string> = {
  '/faq': 'Zuzu Club FAQ: simple answers about anonymous chat, privacy and safety.',
  '/vent-anonymously': 'Zuzu Club: vent anonymously to a real person who chose to listen. Free, no signup.',
  '/talk-to-strangers': 'Zuzu Club: talk to a kind stranger, one to one and anonymous.',
  '/alternatives': 'Zuzu Club compared with 7 Cups, Omegle, Wysa, Replika, TalkLife and more.',
  '/review': 'Enjoying Zuzu Club? Help someone else find it.',
  '/press': 'Zuzu Club press kit (media kit): official logos and real screenshots.',
  '/contact': 'Contact Zuzu Club: questions, ideas, press or a report. A real person reads every message.',
  '/feedback': 'Zuzu Club feedback: help make Zuzu a little better.',
  '/changelog': "What's new on Zuzu Club: every update in plain words.",
  '/ask-ai': 'Ask your AI about Zuzu Club: ChatGPT, Claude, Gemini, Copilot, Perplexity or Grok.',
  '/whimsical-websites': 'The best whimsical websites on the internet, all free, on Zuzu Club: explore 100+ sites by mood or suggest one.',
  '/meet-again': 'Zuzu Club Meet Again: had a good chat? If you both tap Meet again, you can talk again.',
  ...Object.fromEntries(Object.entries(ALTERNATIVE_NAMES).map(([path, name]) =>
    [path, `Zuzu Club, a free ${name} alternative: anonymous chat with a kind stranger. No signup.`])),
};

export const pageImageFile = (path: string) => `zuzu-club-${path.slice(1)}.jpg`;

export const PAGE_IMAGES: Record<string, { image: string; alt: string }> = Object.fromEntries(
  Object.entries(ALTS).map(([path, alt]) => [path, { image: `https://www.zuzu.club/og/${pageImageFile(path)}?v=${PAGE_IMAGE_VERSIONS[path] ?? PAGE_IMAGE_VERSION}`, alt }]),
);
